<template>
	<div class="add-product uplist">
		<div
			v-for="(item1, index1) in info"
			:key="index1"
			style="width: 100%; clear: both">
			<div
				class="tit"
				style="
					color: #000000;
					font-size: 16px;
					font-weight: bold;
					margin-top: 5px;
					display: flex;
					align-items: center;
				">
				<div class="title">{{ item1.title }}</div>
			</div>
			<div
				class="item_area"
				v-for="(item, index) in item1.list"
				:key="index"
				:class="item.classKuan"
				:style="
					$i18n.locale == 'zh_CN' || $i18n.locale == 'ja_JP'
						? 'float: left; margin: 15px 15px 0px 0px; background-color: #FFFFFF; border-radius: 8px; padding: 15px; display: flex; cursor: pointer; width: 293px;'
						: 'float: left; margin: 15px 15px 0px 0px; background-color: #FFFFFF; border-radius: 8px; padding: 15px; display: flex; cursor: pointer; width: 293px;'
				">
				<img
					:src="item.icon"
					style="
						display: block;
						height: 55px;
						width: 55px;
						border-radius: 100%;
					" />
				<div
					@click="handleEntry(item.url, item.type)"
					style="
						margin-left: 15px;
						width: 79%;
						height: 55px;
						display: flex;
						align-items: center;
					">
					<div style="width: 100%">
						<div style="display: flow-root">
							<div
								class="item_area_tit"
								:class="item.className"
								style="float: left; font-weight: 600; font-size: 18px">
								{{ item.title }}
							</div>
						</div>
						<div
							style="
								font-size: 14px;
								color: #969696;
								white-space: nowrap;
								overflow: hidden;
								text-overflow: ellipsis;
							">
							{{ item.desc }}
						</div>
					</div>
				</div>
			</div>
		</div>

		<el-dialog
			:modal-append-to-body="true"
			:append-to-body="true"
			:title="$t('upgrade.appDownConfig')"
			:visible.sync="dialogVisibleDownConfig"
			width="30%"
			:before-close="handleClose">
			<div v-loading="downLoading">
				<div
					class="item_down_config"
					v-for="(item, index) in downConfig"
					:key="index">
					<div class="item_down_tit">{{ item.title }}</div>
					<div class="item_down_pre">
						<span>{{ $t("upgrade.codeReview") }}:</span>
						<div>
							<img :src="item.code" alt="" style="width: 100%; height: 100%" />
						</div>
					</div>
					<div class="item_down_ver" v-if="!item.isH5">
						<span>{{ $t("upgrade.versionChoose") }}</span>
						<el-select
							size="small"
							v-model="item.defaultVer"
							@change="handlerChange($event, item.verList, index)">
							<el-option
								v-for="(value, idx) in item.verList"
								:key="value.id"
								:label="value.appVersion"
								:value="value.id">
							</el-option>
						</el-select>
					</div>
					<div v-if="!item.isH5" class="item_down_ver">
						<span>{{ $t("upgrade.downUrl") }}:</span>
						<el-input disabled size="small" v-model="item.downUrl"></el-input>
					</div>
					<div v-else class="item_down_ver">
						<span>{{ $t("upgrade.useLink") }}:</span>
						<el-input size="small" v-model="item.downUrl"></el-input>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer" v-if="!downLoading">
				<el-button @click="dialogVisibleDownConfig = false">{{
					$t("common.cancel")
				}}</el-button>
				<el-button type="primary" @click="handlerSave">{{
					$t("common.definite")
				}}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: "UpgradeList",
	components: {},
	data() {
		return {
			loading: false,
			superAdminPassword: "",
			dialogVisibleMaster: false,
			dialogVisibleExitApk: false,
			dialogVisibleDownConfig: false,
			downLoading: false,
			apps: {},
			logolist: [],
			iconlist: [],
			homeSignImglist: [],
			homeBackImglist: [],
			editorOption: {},
			authNow: "",
			userIdArr: [],
			authList: [],
			downConfig: [
				{
					title: this.$t("upgrade.azdown"),
					code: "",
					defaultVer: "",
					verList: [],
					downUrl: "",
				},
				{
					title: this.$t("upgrade.iosdown"),
					code: "",
					defaultVer: "",
					isH5: true,
					verList: [],
					downUrl: "",
				},
				{
					title: this.$t("upgrade.h5ve"),
					code: "",
					defaultVer: "",
					isH5: true,
					verList: [],
					downUrl: "",
				},
			],
			info: [
				{
					title: this.$t("upgrade.apkmer"),
					isDown: false,
					isMaster: true,
					list: [
						{
							icon: require("_as/zhuti.png"),
							title: this.$t("upgrade.doorApk"),
							desc: this.$t("upgrade.doorApkDesc"),
							type: 1,
							price: 0,
							url: "/upgrade/apk",
							className: "",
							classKuan: "xuanfuy",
						},
						{
							icon: require("_as/zhuti.png"),
							title: this.$t("upgrade.android026"),
							desc: this.$t("upgrade.android026Desc"),
							type: 2,
							price: 0,
							url: "/upgrade/apk",
							className: "",
							classKuan: "xuanfuy",
						},
					],
				},
			],

			dialogBuyPannel: false,
			iteminfo: {},
			active: 0,
			process: "",
			payStatus: "",
			orderNumber: "",
			confirmRenew: "",
			localuserid: "",
			nowType: "",
		};
	},
	mounted() {},
	methods: {
		handlerChange(e, list, index) {
			if (list.length > 0) {
				list.forEach(item => {
					if (item.id == e) {
						this.downConfig[index].defaultVer = item.appVersion;
						this.downConfig[index].downUrl = item.downUrl;
					}
				});
			}
		},
		// App下载配置修改
		handlerSave() {
			let obj = {
				androidVersion: this.downConfig[0].defaultVer,
				androidDownUrl: this.downConfig[0].downUrl,
				androidQrCode: this.downConfig[0].code,
				iosVersion: this.downConfig[1].defaultVer,
				iosDownUrl: this.downConfig[1].downUrl,
				iosQrCode: this.downConfig[1].code,
				h5Version: this.downConfig[2].defaultVer,
				h5DownUrl: this.downConfig[2].downUrl,
				h5QrCode: this.downConfig[2].code,
			};
			this.$api
				.request(this.$url.Upgrade.appDownConfigSave, this.$method.post, obj)
				.then(res => {
					if (res.code === 0) {
						this.$message.success(res.msg);
						this.dialogVisibleDownConfig = false;
					}
				});
		},
		// 超级管理员密码设置
		handlerMasterSet() {
			let _self = this;
			_self.dialogVisibleMaster = true;
		},
		handlerChangeAdminPassword() {
			let _self = this;
			let obj = { pwd: _self.superAdminPassword };
			this.$api
				.request(this.$url.Upgrade.superAdminPwdChange, this.$method.post, obj)
				.then(res => {
					if (res.code === 0) {
						_self.dialogVisibleMaster = false;
						this.$message.success(res.msg);
					}
				});
		},
		// 下载配置
		async handlerDownConfig() {
			let _self = this;
			_self.dialogVisibleDownConfig = true;
			_self.downLoading = true;
			// 安卓版本号
			let androidOptions = await this.$api.request(
				this.$url.Upgrade.appList,
				this.$method.get,
				{ type: 5, pageSize: 999 }
			);
			this.downConfig[0].verList = [];
			this.downConfig[0].verList = androidOptions.data.records;

			// ios版本号
			let iosOptions = await this.$api.request(
				this.$url.Upgrade.appList,
				this.$method.get,
				{ type: 6, pageSize: 999 }
			);
			this.downConfig[1].verList = [];
			this.downConfig[1].verList = iosOptions.data.records;

			let res = await this.$api.request(
				this.$url.Upgrade.appDownConfig,
				this.$method.get
			);
			if (res.code === 0) {
				this.downLoading = false;
				this.downConfig[0].code = res.data.androidQrCode || "";
				this.downConfig[0].defaultVer = res.data.androidVersion || "";
				this.downConfig[0].downUrl = res.data.androidDownUrl || "";
				this.downConfig[1].code = res.data.iosQrCode || "";
				this.downConfig[1].defaultVer = res.data.iosVersion || "";
				this.downConfig[1].downUrl = res.data.iosDownUrl || "";
				this.downConfig[2].code = res.data.h5QrCode || "";
				this.downConfig[2].defaultVer = res.data.h5Version || "";
				this.downConfig[2].downUrl = res.data.h5DownUrl || "";
			}
		},

		handleEntry(url, type) {
			if (url) {
				window.localStorage.setItem("wType", type);
				this.$router.push({
					path: url,
				});
			}
		},
	handleClose() {
		this.dialogVisibleDownConfig = false;
	},
	},
};
</script>

<style lang="scss" scoped>
.xuanfuy {
	border: 1px solid #ffffff;
}
.show {
	color: #409eff;
}
.editor {
	height: 300px;
}
.el-form--label-top .el-form-item__label {
	padding: 0;
}
.add-product {
	background-color: #f2f2f2;
	display: flow-root;
	padding-bottom: 15px;
	.el-upload--picture-card {
		width: 80px;
		height: 80px;
		line-height: 88px;
	}
	.el-upload-list__item {
		width: 80px !important;
		height: 80px !important;
		margin-bottom: 0 !important;
	}
	.el-form-item__content {
		line-height: 0;
	}
}
.item_area:hover {
	border: 1px solid #409eff;
	.item_area_tit {
		color: #409eff;
	}
}
.add-product {
	div {
		.tit {
			padding-top: 20px;
		}
	}
	div:nth-of-type(1) {
		.tit {
			padding: 0;
		}
	}
}
.uplist {
	::v-deep .el-dialog__title {
		font-weight: bolder;
	}
	::v-deep .el-dialog__body {
		height: auto;
	}
}
.item_down_config {
	margin-bottom: 30px;
	.item_down_tit {
		font-weight: bolder;
		font-size: 16px;
		line-height: 1.2;
	}
	.item_down_pre {
		display: flex;
		align-items: center;
		padding: 10px 0;
		div {
			height: 66px;
			width: 66px;
			background-color: #f2f2f2;
			margin-left: 40px;
		}
	}
	.item_down_ver {
		display: flex;
		flex-direction: column;
		.el-select {
			margin: 16px 0;
			width: 160px;
		}
		.el-input {
			margin: 16px 0;
			width: 300px;
		}
	}
}
</style>
